import anime from 'animejs';
import help from '../../_scripts/helpers';

class MoreText {
	constructor(props) {
		if ( !this._initHtml(props) ) return false;

		this._initMore();
		this._initToggle();
	}
	_initHtml(props) {
		if (!props.root) return false;

		this.root = props.element || document.querySelector(`[${props.root}]:not([${props.root}-inited])`);
		if (!this.root) return false;

		this.root.setAttribute(`${props.root}-inited`, true);

		this.wrapper = this.root.querySelector(`[${props.root}-wrapper]`);
		this.link = this.root.querySelector(`[${props.root}-link]`);
		this.linkText = this.root.querySelector(`[${props.root}-link-text]`);

		this.toggleText = [this.linkText.textContent, this.root.getAttribute(`${props.root}`)];

		return true;
	}
	_initMore() {
		this.isOpen = false;

		this._toggle = this._toggle.bind(this);

		let defaultLineHeight = parseFloat(getComputedStyle(this.wrapper).lineHeight);
		this.defaultMaxHeight = (this.root.dataset.maxHeight) ? `${this.root.dataset.maxHeight}px` : `${defaultLineHeight * 5}px`;

		this._calcDefaultValues();
		this._initToggle();

		window.addEventListener('resize', help.debounce(e => {
			this._calcDefaultValues();
			this._initToggle();
		}, 250));
	}
	_calcDefaultValues() {
		this._reset();

		this.wrapper.style.setProperty('max-height', this.defaultMaxHeight);
		this.wrapper.style.setProperty('height', 'auto');

		this.maxHeight = parseFloat(getComputedStyle(this.wrapper).maxHeight);
		this.innerHeight = this._getChildHeights();
	}
	_initToggle() {
		this._removeListeners();

		if (this.innerHeight > this.maxHeight) {
			this._showLink();
			this._addListeners();
		} else {
			this._hideLink();
		}
	}
	_removeListeners() {
		this.link.removeEventListener('click', this._toggle);
	}
	_addListeners() {
		this.link.addEventListener('click', this._toggle);
	}
	_toggle(e) {
		e.preventDefault();

		if (this.isOpen) {
			this._close();
		} else {
			this._open();
		}
	}
	_open() {
		this.isOpen = true;

		// почему-то не срабаывает begin при первом запуске, с setTimeout работает
		setTimeout(() => {
			anime({
				targets: this.wrapper,
				height: [`${this.maxHeight}px`, `${this.innerHeight}px`],
				duration: 450,
				easing: 'easeOutQuad',
				begin: () => {
					this.linkText.innerText = this.toggleText[1];
					this.link.classList.add('is-toggle');
					this.wrapper.style.setProperty('max-height', 'none');
				}
			});
		}, 0)
	}
	_close() {
		this.isOpen = false;

		anime({
			targets: this.wrapper,
			height: this.maxHeight,
			duration: 450,
			easing: 'easeOutQuad',
			begin: () => {
				this.link.classList.remove('is-toggle');
				this.linkText.innerText = this.toggleText[0];
			},
			complete: () => {
				this.wrapper.style.setProperty('max-height', `${this.maxHeight}px`);
			}
		});
	}
	_reset() {
		this.isOpen = false;
		this.link.classList.remove('is-toggle');
		this.linkText.innerText = this.toggleText[0];
	}
	_hideLink() {
		this.link.classList.remove('is-active');
	}
	_showLink() {
		this.link.classList.add('is-active');
	}
	_getChildHeights() {
		return [...this.wrapper.children].reduce((sum, item) => {
			return sum + item.getBoundingClientRect().height;
		}, 0);
	}
}


class MoreTexts {
	constructor(props) {
		if (!props.root) return false;

		[...document.querySelectorAll(`[${props.root}]:not([${props.root}-inited])`)].forEach(el => {
			new MoreText({
				root: props.root,
				element: el
			});
		});
	}
}

export {MoreTexts, MoreText}